




















import Vue, { PropOptions } from 'vue';

export type ProductHuntBadge = Blok & {
  title?: string;
  subTitle?: string;
  icon?: { filename: string };
  url?: { url: string };
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<ProductHuntBadge>,
  },
});
